const BUSY_INDICATOR = 'BUSY_INDICATOR';
const DECREASE = 'DECREASE';
const INCREASE = 'INCREASE';
const NOTIFICATION = 'NOTIFICATION';

export { BUSY_INDICATOR, DECREASE, INCREASE, NOTIFICATION };
